<script setup lang="ts">
import TranscendBannerImage from '@images/transcend-hackathon-header.webp';
</script>

<template>
  <a
    class="d-inline-block w-100"
    href="https://gitlab-transcend.devpost.com/"
    target="_blank"
    title="Register for the Transcend Hackathon on Devpost"
  >
    <img
      class="mw-100 mh-100 object-fit-contain"
      :src="TranscendBannerImage"
      alt="Transcend Hackathon - register on Devpost"
    >
  </a>
</template>
